<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { getUserIP } from '@/api/view'
export default {
  name: 'App',
  mounted() {
    console.log(localStorage.getItem('userIP'))
    if (!localStorage.getItem('userIP')) {
      this.userIP()
    }
  },
  methods: {

    async userIP() {
      await getUserIP()
        .then((response) => {
          const ip = response.ip
          localStorage.setItem('userIP', ip)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style>
html, body {
  padding: 0;
  margin: 0;
}
* {
  font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
}
.el-progress-bar__innerText {
  color: #000;
  font-weight: 520;
}
.el-divider--horizontal {
  margin:0
}
.mhc-button {
   font-weight:600;
   font-size:0.5rem;
   letter-spacing:2px;
   text-transform: uppercase
}
.el-upload {
  width: 100% !important;
}
.el-tabs__item {
  font-size: 16px !important;
}
.pretty-title::before {
    display: inline-block;
    content: '';
    width: 4px;
    height: 20px;
    margin-right: 10px;
    border-radius: 1px;
    background-color: var(--subtext-color);
    background-color: rgb(40, 95, 202);
}
.pretty-title {
  background-color: rgb(246, 248, 253);
  border-radius: 5px;
  height: 60px;
  color: rgb(40, 95, 202);
  line-height: 60px;
  font-size: 28px;
  font-weight: 540;
  text-align: left;
  margin-bottom: 20px;
}
.el-cascader-panel{
    max-height: 300px;
  }
</style>
